import * as d3 from 'd3';
import { TDrawModel } from '../../draw.model';
import { TEntityGroups } from '../../timeline.types';

type OverlayTarget = {
  selection: d3.Selection<
    d3.BaseType | SVGGElement | SVGSVGElement,
    TEntityGroups<unknown, unknown, unknown>,
    d3.BaseType,
    TDrawModel
  >;
  className: 'entity-disabled-overlay' | 'left-nav-disabled-overlay';
};

const drawDisabledEntityOverlays = (targets: OverlayTarget[], drawModel: TDrawModel) => {
  targets.forEach(({ selection, className }) => {
    selection
      .selectAll(`.${className}`)
      .data((d) => d.entities)
      .join('rect')
      .classed(className, true)
      .attr('x', 0)
      .attr('y', (_, i) => drawModel.layout.entityHeight * i)
      .attr('width', '100%')
      .attr('height', drawModel.layout.entityHeight)
      .attr('fill', 'rgba(128, 128, 128, 0.2)')
      .style('pointer-events', 'none')
      .attr('display', (d) => (d.disabled ? null : 'none'));
  });
};

export const DRAW_OVERLAYS = { drawDisabledEntityOverlays };
